module.exports = __webpack_public_path__ + "img/tseipoaoi.3c45cf37.png";